import { render } from "./ContentBanners.vue?vue&type=template&id=4e418f44&lang=pug"
import script from "./ContentBanners.vue?vue&type=script&lang=js"
export * from "./ContentBanners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__